import { observer } from 'mobx-react-lite';
import React, { useContext, useRef } from 'react';
import { Col } from 'react-bootstrap';
import Slider from 'react-slick';
import { ProductInfoModal } from '../../../../product-info/util/ProductInfoModal';
import { KitGridItemDesktop } from '../../../common-er/util-er-kit/kit-grid/KitGridItemDesktop';
import { KitGridItemCustom } from '../../../common-er/util-er-kit/kit-grid/KitGridItemCustom';
import { KitGridItem } from '../../../common-er/util-er-kit/kit-grid/KitGridItem';
import { KitPriceDisplay } from '../../../common-er/util-er-kit/KitPriceDisplay';
import { KitGridItemCustomPsk } from '../../../common-er/util-er-kit/kit-grid/KitGridItemCustomPsk';
import { useRootStore } from '../../../../root/RootStoreHooks';
import { KitSlider } from '../../../starter-kit-selection/tab-content/card/KitSlider';
import './KitGrid.scss';

export const KitGridDesktop = observer(function KitGrid() {
  const root = useRootStore();
  const store = root.moduleStores.erKitSelection ?? root.moduleStores.socialLinkErKitSelection!;
  const slidesToShow = 4 -(store.canCustomizeErKit ? 1 : 0) - (store.canCustomizeErWithPsk ? 1 : 0) ;
  const customLength = (store.canCustomizeErKit ? 1 : 0) + (store.canCustomizeErWithPsk ? 1 : 0); 
  const length = store.erKits.length + (store.canCustomizeErKit ? 1 : 0) + (store.canCustomizeErWithPsk ? 1 : 0);
  const doubleCustomBlock = ((store.canCustomizeErKit ? 1 : 0) + (store.canCustomizeErWithPsk ? 1 : 0)) == 2;
  let slidesToShowOneItem: number; 
  if (doubleCustomBlock) {
    slidesToShowOneItem = store.erKits.length === 1 ? 1 : 2;
  } else {
    slidesToShowOneItem = 3;
  }
  let slidesToColSize: number;

  if (doubleCustomBlock) {
    slidesToColSize = store.erKits.length === 1 ? 3 : 5;
  } else {
    slidesToColSize = 8;
  }
  
  return (
    <div className="container mb-4">
      <Col md={12}>
        {length <= slidesToShow ? (
          <div className="row">
            <Col md={doubleCustomBlock ? 6 : 3}>
                <div className='erkit-custom-container'>
                {store.canCustomizeErKit && (
                  <KitGridItemDesktop key="KitGridItemCustom">
                    <KitGridItemCustom
                      customKitSelected={store.customKitSelected}
                      selectCustomizeKit={store.selectCustomizeKit}
                    />
                  </KitGridItemDesktop>
                )}
                {store.canCustomizeErWithPsk && (
                  <KitGridItemDesktop key="KitGridItemCustomPsk">
                    <KitGridItemCustomPsk
                      customKitWithPskSelected={store.customKitWithPskSelected}
                      selectCustomizeKitWithPsk={store.selectCustomizeKitWithPsk}
                    />
                  </KitGridItemDesktop>
                )}
              </div>
            </Col>
            <Col md={doubleCustomBlock ? 5 : 8}>
              <div className='erkit-grid-container'>
                {store.erKits.map(kit => (
                  <KitGridItemDesktop key={kit.itemId}>
                    <KitGridItem
                      key={kit.itemId}
                      kit={kit}
                      showProductInfo={store.showProductInfo}
                      choseKit={store.choseKit}
                      selectedKit={store.selectedKit}
                    />
                  </KitGridItemDesktop>
                ))}
              </div>
            </Col>
          </div>
          ) : (
          <div className="row ">
            <Col md={doubleCustomBlock ? 6 : 3}>
              <div className='erkit-custom-container-slider'>
                {store.canCustomizeErKit && (
                  <KitGridItemDesktop key="KitGridItemCustom">
                    <KitGridItemCustom
                      customKitSelected={store.customKitSelected}
                      selectCustomizeKit={store.selectCustomizeKit}
                    />
                  </KitGridItemDesktop>
                )}
                {store.canCustomizeErWithPsk && (
                  <KitGridItemDesktop key="KitGridItemCustomPsk">
                    <KitGridItemCustomPsk
                      customKitWithPskSelected={store.customKitWithPskSelected}
                      selectCustomizeKitWithPsk={store.selectCustomizeKitWithPsk}
                    />
                  </KitGridItemDesktop>
                )}
              </div>
              </Col>
              <Col md={slidesToColSize}>
                <div className='erkit-grid-container-slider'>
                  <KitSlider kits={store.erKits} slidesToShow={slidesToShowOneItem} store={store}/>
                </div>
              </Col>
          </div>
          )}
        {store.productInfo && (
          <ProductInfoModal
            isOpen={store.showProductModal}
            onClose={() => store.hideProductInfo()}
            onKitSelected={() => store.choseKit(store.productInfo!.kit)}
            productInfo={store.productInfo}
            priceDisplay={<KitPriceDisplay kit={store.productInfo.kit} />}
          />
        )}
      </Col>
    </div>
  );
});
